/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect } from "react";
import { AppMain } from "./layouts/AppMain";
import { BASE_URL, paramsToObject } from "./store/api";
import { useLocation } from "react-router-dom";
import { RootState } from "./store/rootReducer";
import { AppMessage } from "./layouts/AppMessage";
import { AppLoading } from "./layouts/AppLoading";
import { useDispatch, useSelector } from "react-redux";
import { getUserAsync, updateError } from "./reducers/authorization/authorization.actions";

const App = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const isLoading = useSelector((state: RootState) => state.authorization.isLoading);
  const error = useSelector((state: RootState) => state.authorization.error);
  const message = useSelector((state: RootState) => state.authorization.message);

  const appendScript = (path: string) => {
    const scriptAppender = document.createElement("script");
    scriptAppender.src = path;
    scriptAppender.async = true;
    document.body.appendChild(scriptAppender);
  };

  useEffect(() => {
    setTimeout(() => {
      const devMode = false;
      let token = [];

      if (devMode) {
        token = [
          '',
          '',
          '',
          [
            '',
            '',
            'sos22htgB1M2Q5QZySJZ8IyBIPuD9bTM'
          ]
        ]
      } else {
        let cookie = '';
        const cookieName = 'cookie_monster';
        const theCookie = '' + document.cookie;
        const ind = theCookie.indexOf(cookieName);
        let ind1 = theCookie.indexOf(';', ind);
        if (ind1 === -1) ind1 = theCookie.length;
        if (ind === -1) cookie = '';
        cookie = unescape(theCookie.substring(ind + cookieName.length + 1, ind1));
        cookie = cookie.replace(/['"]+/g, '');
        cookie = cookie.substring(cookie.indexOf('{', 0));
        cookie = cookie.substring(1, cookie.length);
        cookie = cookie.substring(0, cookie.length - 1);
        token = cookie.split(';').map(item => {
          return item.split(':');
        });  
      }
      
      if (token && token[3] && token[3][2]) {
        dispatch(getUserAsync.request({ authToken: token[3][2] }));
      } else {
        const filter = paramsToObject(location.search);
        if (filter && filter.error) {
          dispatch(updateError({
            name: 'Forbidden',
            message: 'Email Anda tidak terdaftar pada server sistem kerjasama UMN. Silahkan hubungi tim International Office untuk melakukan pendaftaran.',
            code: 401,
            status: 401
          }));
          return;
        }
        window.location.href = `${BASE_URL}account/login`;
      }
    }, 1000)

    // fundamentals for adminlte basic requirement scripts
    setTimeout(() => appendScript("/adminlte/preq/jquery/dist/jquery.min.js"), 100);
    setTimeout(() => appendScript("/adminlte/preq/bootstrap/dist/js/bootstrap.min.js"), 200);
    setTimeout(() => appendScript("/adminlte/js/adminlte.min.js"), 300);
  }, []);

  if (isLoading || error) {
    return <AppLoading />
  } else {
    if (message) return <AppMessage />
    return <AppMain />
  }
};

export default App;
